// extracted by mini-css-extract-plugin
module.exports = {"container":"Video-module--container--NjAyK","layout":"Video-module--layout--36N62","wrapper":"Video-module--wrapper--xAjEp"};